export default __webpack_public_path__ + "static/media/networkHospital.f23e3b9f.svg";